import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface NavSidebarState {
	open: boolean;
	type?: 'products' | 'brands' | string;
}
@Injectable({ providedIn: 'root' })
export class NavSidebarService {
	private _state$ = new BehaviorSubject<NavSidebarState>({ open: false });
	readonly state$ = this._state$.asObservable();

	private _open$ = new BehaviorSubject<boolean>(false);
	readonly open$ = this._open$.asObservable();

	open(type: string) {
		this._state$.next({ open: true, type });
	}

	close() {
		this._state$.next({ open: false });
	}
}
